import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faChevronRight,
  faChevronDown,
  faDove,
  faChevronLeft,
  faEdit,
} from "@fortawesome/free-solid-svg-icons";
import { useShoppingContext } from "../../../context/ShoppingContext";
import "./EditGalpon.css";
import "../Edit.css"; // Importar el archivo CSS compartido

const EditGalpon = () => {
  const { id } = useParams(); // Obtener el ID del galpón desde la URL
  const navigate = useNavigate();
  const { fetchGalponAves, aves } = useShoppingContext(); // Fetch functions from context

  const [galpon, setGalpon] = useState({
    nombre: "",
    largo: "",
    ancho: "",
    granjaId: "",
  });
  const [openAves, setOpenAves] = useState({}); // Estado para controlar qué aves están desplegadas
  const [error, setError] = useState("");

  useEffect(() => {
    fetchGalponAves(id); // El 'id' aquí es el galponId obtenido desde useParams
  }, [id, fetchGalponAves]);

  useEffect(() => {
    const loadGalpon = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/galpones/${id}`
        );
        setGalpon(response.data);
      } catch (error) {
        console.error("Error fetching galpon:", error);
        setError("Error al cargar los datos del galpón.");
      }
    };
    loadGalpon();
  }, [id]);

  const toggleAve = (aveId) => {
    setOpenAves((prevOpenAves) => ({
      ...prevOpenAves,
      [aveId]: !prevOpenAves[aveId], // Alternar el estado desplegado de cada ave
    }));
  };

  const handleDeleteAve = async (aveId, nombre) => {
    if (
      window.confirm(
        `¿Estás seguro de que quieres eliminar el ave "${nombre}"?`
      )
    ) {
      try {
        await axios.delete(`${process.env.REACT_APP_API_URL}/aves/${aveId}`);
        fetchGalponAves(id); // Actualizar la lista de aves después de eliminar
      } catch (error) {
        console.error("Error al eliminar el ave:", error);
        setError(error.response?.data?.message || "Error al eliminar el ave");
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setGalpon((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/galpones/${id}`,
        galpon
      );
      navigate("/mis-galpones"); // Navigate back to the galpon list
    } catch (error) {
      console.error("Error updating galpon:", error);
      setError("Error al actualizar los datos del galpón.");
    }
  };

  return (
    <div className="edit-container">
      <button
        className="btn btn-back"
        onClick={() => navigate(-1)} // Regresar a la página anterior
      >
        <FontAwesomeIcon icon={faChevronLeft} /> Volver
      </button>
      <h1 className="flex-space-between">
        {galpon?.nombre}{" "}
        <span className="IdEditContainer"> id: {galpon?.id}</span>
      </h1>
      {error && <p className="text-danger">{error}</p>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="nombre">Nombre del Galpón</label>
          <input
            type="text"
            id="nombre"
            name="nombre"
            value={galpon.nombre}
            onChange={handleChange}
            className="form-control"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="largo">Largo (metros)</label>
          <input
            type="number"
            id="largo"
            name="largo"
            value={galpon.largo}
            onChange={handleChange}
            className="form-control"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="ancho">Ancho (metros)</label>
          <input
            type="number"
            id="ancho"
            name="ancho"
            value={galpon.ancho}
            onChange={handleChange}
            className="form-control"
            required
          />
        </div>
        <button type="submit" className="btn btn-primary">
          Guardar Cambios
        </button>
      </form>

      <h3>
        {aves.length > 0
          ? `Aves en este Galpón`
          : `No hay aves registradas en este galpón`}
      </h3>
      {aves.length > 0 ? (
        <ul className="aves-list">
          {aves.map((ave) => (
            <li key={ave.id} className="ave-item">
              <div
                className="ave-header"
                onClick={() => toggleAve(ave.id)} // Alternar el desplegable
              >
                <div className="flex-space-between">
                  <div>
                    <FontAwesomeIcon className="dove" icon={faDove} />
                    <FontAwesomeIcon
                      className="ave-header-icon"
                      icon={openAves[ave.id] ? faChevronDown : faChevronRight}
                    />
                    <strong>{ave.nombre}</strong>
                  </div>
                  <div>
                    <FontAwesomeIcon
                      onClick={() => navigate(`/edit-ave/${ave.id}`)}
                      icon={faEdit}
                    />
                    <button
                      className="delete-button"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteAve(ave.id, ave.nombre);
                      }}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </div>
                </div>
              </div>

              {/* Mostrar Alimento, Producción y Mortalidad solo si el ave está desplegada */}
              {openAves[ave.id] && (
                <ul className="ave-details-list">
                  <li>
                    <strong>Alimento:</strong> {ave.alimento} kg
                  </li>
                  <li>
                    <strong>Producción:</strong> {ave.produccion} huevos
                  </li>
                  <li>
                    <strong>Mortalidad:</strong> {ave.mortalidad} aves
                  </li>
                </ul>
              )}
            </li>
          ))}
        </ul>
      ) : (
        <p>No hay aves registradas en este galpón.</p>
      )}
    </div>
  );
};

export default EditGalpon;
